import { render, staticRenderFns } from "./artefact-sillhouette.vue?vue&type=template&id=f7a4e088&scoped=true&"
import script from "./artefact-sillhouette.vue?vue&type=script&lang=ts&"
export * from "./artefact-sillhouette.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-sillhouette.vue?vue&type=style&index=0&id=f7a4e088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a4e088",
  null
  
)

export default component.exports